import { get, post, put } from 'api/axiosApi';
import { env } from 'utils/env';
//import { put, post } from "api/api";

const url = env.REACT_APP_LEASING_API_URL;

export const getProductSelectionData = (documentId, siteId) => get(`${url}/leasingOffers/${documentId}/${siteId}/product-selection-data`);

export const computeOfferMaxResidualValuePercent = (documentId, siteId, financingStructure) =>
  put(`${url}/leasingOffers/${documentId}/${siteId}/financingStructure/residualvalue`, {
    documentId,
    siteId,
    financingStructure
  });

export const recomputeSimulations = (
  documentId,
  siteId,
  financingPeriod,
  advancePercent,
  residualValuePercent,
  maxResidualPercent,
  agreedMileage,
  contractTypes
) =>
  put(`${url}/leasingOffers/offer-simulations`, {
    documentId,
    siteId,
    financingPeriod,
    advancePercent,
    residualValuePercent,
    maxResidualPercent,
    agreedMileage,
    contractTypes
  });

export function addNewFinancialProduct(documentId, siteId, financialProductId) {
  return put(url + '/leasingoffers/add-new-product', { documentId, siteId, financialProductId });
}

export function getFinancialProductsToAdd(documentId, siteId) {
  return post(url + '/leasingoffers/financial-products-to-add', { documentId, siteId });
}

export const selectSimulation = (documentId, siteId, simulationDocumentId, simulationSiteId) =>
  put(`${url}/leasingOffers/select-simulation`, {
    documentId,
    siteId,
    simulationDocumentId,
    simulationSiteId
  });

export const chooseFavoriteProduct = (documentId, siteId, simulationDocumentId, simulationSiteId, priority) =>
  put(`${url}/leasingOffers/choose-favorite-product`, {
    documentId,
    siteId,
    simulationDocumentId,
    simulationSiteId,
    priority
  });

export const deleteProduct = (documentId, siteId, simulationDocumentId, simulationSiteId) =>
  put(`${url}/leasingOffers/delete-product`, {
    documentId,
    siteId,
    simulationDocumentId,
    simulationSiteId
  });
